// internal deps
import { ApiFetchState } from "@swiggy-private/payment-core";
import { PayLaterLinkedMeta } from "@swiggy-private/payment-ui";

export type PayLaterLinkState = {
    [key: string]: PayLaterLinkStateValue;
};

export type PayLaterLinkStateValue = {
    fetchState: ApiFetchState;
    linked: boolean;
    meta?: PayLaterLinkedMeta;
    enabled?: boolean;
    disableMessage?: string;
};

export const defaultPayLaterLinkStateValue: PayLaterLinkStateValue = {
    fetchState: ApiFetchState.SUCCESS,
    linked: false,
};

export enum GetPayLaterLinkActionTypes {
    REQUEST,
    SUCCESS,
    ERROR,
}

export type GetPayLaterLinkAction =
    | { type: GetPayLaterLinkActionTypes.REQUEST; name: string }
    | { type: GetPayLaterLinkActionTypes.SUCCESS; name: string; payload: Omit<PayLaterLinkStateValue, "fetchState"> }
    | { type: GetPayLaterLinkActionTypes.ERROR; name: string };

export function getPayLaterLinkReducer(state: PayLaterLinkState, action: GetPayLaterLinkAction): PayLaterLinkState {
    switch (action.type) {
        case GetPayLaterLinkActionTypes.REQUEST:
            return { ...state, [action.name]: { ...(state[action.name] ?? {}), fetchState: ApiFetchState.LOADING } };
        case GetPayLaterLinkActionTypes.SUCCESS:
            return {
                ...state,
                [action.name]: { ...(state[action.name] ?? {}), ...action.payload, fetchState: ApiFetchState.SUCCESS },
            };
        case GetPayLaterLinkActionTypes.ERROR:
            return { ...state, [action.name]: { ...(state[action.name] ?? {}), fetchState: ApiFetchState.ERROR } };
    }
}
